<h1 mat-dialog-title>
  @if (data.title) {
    <span>{{data.title}}</span>
  } @else {
    <span>Add Item</span>
  }
</h1>
@if (this.data.scope === 'Global') {
  <div mat-dialog-content>
    <mat-form-field>
      <mat-label>Enter a new Submenu name</mat-label>
      <input
        [attr.data-testid]="'submenu_name_text'"
        [formControl]="name"
        matInput
        placeholder="Start typing"
        required
        />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Enter a new Submenu tag</mat-label>
      <input
        [attr.data-testid]="'submenu_id_text'"
        [formControl]="id"
        matInput
        placeholder="Start typing"
        (focusout)="submenuTagValidation()"
        required
        />
      @if (id.errors) {
        <mat-error>
          Submenu tags can only contain capital letters, numbers, and underscores
        </mat-error>
      }
    </mat-form-field>
    @if (tagExists) {
      <div class="mat-error">
        {{ errorMessage }}
      </div>
    }
    <mat-form-field>
      <mat-label>Select a Submenu to Copy (Optional)</mat-label>
      <mat-select [formControl]="copyFromId" name="copyFromId">
        @for (option of options; track option) {
          <mat-option
            [attr.data-testid]="option.name + '_option'"
            [value]="option.id"
          >{{ option.id }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (displayAddGlobal) {
      <div class="toggle-question">
        <mat-slide-toggle
          [attr.data-testid]="'add_global_toggle'"
          [formControl]="addGlobal"
          ><span class="toggle-label">Add Global</span></mat-slide-toggle>
        </div>
      }
    </div>
  }
  <div mat-dialog-actions>
    <button
      [attr.data-testid]="'cancel_button'"
      mat-raised-button
      matTooltip="Cancel"
      class="button-color"
      (click)="cancelAddItem()"
    >Cancel</button>
    <button
      [attr.data-testid]="'ok_button'"
      class="button-color"
      [disabled]="tagExists || (isReadOnly$ | async) || isSaveDisabled() || id.invalid"
      mat-raised-button
      matTooltip="Save"
      (click)="addItem()"
    >Ok</button>
  </div>
